// Returns everything but the last element of the array
export const initial = <T>(arr: T[]) => arr.slice(0, arr.length - 1);
